import { ReactComponent as Alert } from 'assets/icons/icon-alert.svg';

export default Alert;
